<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <div class="row">
          <div class="col-lg-6">
            <company-select
              id="repairer-company-select"
              heading="Repairer"
              helper="Enter the details of the repairer"
              :types="companyTypes"
              :company="getCompany"
              ref="company"
            ></company-select>
          </div>
          <div class="col-lg-6">
            <input-block
              name="repair_deal_reason"
              label="Repair deal reason"
              v-model="form.repair_deal_reason"
              helper="Please enter repair deal reason"
              :show-error="form.errors.has('repair_deal_reason')"
              :error-message="form.errors.get('repair_deal_reason')"
            ></input-block>

            <currencyinput
              name="labour_value"
              label="Labour Value"
              v-model="form.labour_value"
              helper="Please enter the labour value"
              :show-error="form.errors.has('labour_value')"
              :error-message="form.errors.get('labour_value')"
            ></currencyinput>

            <currencyinput
              name="parts_value"
              label="Parts Value"
              v-model="form.parts_value"
              helper="Please enter the parts value"
              :show-error="form.errors.has('parts_value')"
              :error-message="form.errors.get('parts_value')"
            ></currencyinput>

            <currencyinput
              name="paint_materials_value"
              label="Paint & Materials Value"
              v-model="form.paint_materials_value"
              helper="Please enter the paint & materials value"
              :show-error="form.errors.has('paint_materials_value')"
              :error-message="form.errors.get('paint_materials_value')"
            ></currencyinput>

            <currencyinput
              name="engineers_fee"
              label="Engineers Fee"
              v-model="form.engineers_fee"
              helper="Please enter the engineers fee"
              :show-error="form.errors.has('engineers_fee')"
              :error-message="form.errors.get('engineers_fee')"
            ></currencyinput>

            <currencyinput
              name="admin_fee"
              label="Admin Fee"
              v-model="form.admin_fee"
              helper="Please enter the admin fee"
              :show-error="form.errors.has('admin_fee')"
              :error-message="form.errors.get('admin_fee')"
            ></currencyinput>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend>
                Inspection Location
                <small class="text-muted">
                  - Enter the inspection location
                </small>
              </legend>
              <address-lookup
                :address="inspectionAddress"
                v-on:address="setInspectionLocation"
              ></address-lookup>
            </fieldset>
          </div>
          <div class="col-lg-6">
            <fieldset>
              <legend>
                Storage Location
                <small class="text-muted">
                  - Enter the storage location
                </small>
              </legend>
              <address-lookup
                :address="storageAddress"
                v-on:address="setStorageLocation"
              ></address-lookup>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button
          level="warning"
          :indicator="requestCvdIndicator"
          :disabled="!repair_exists || cvdRequested"
          :title="repairNotSavedWarning"
          v-on:clicked="requestClientJob('client_delivery')"
        >
          {{
            cvdRequested
              ? 'Client Vehicle Delivery Requested'
              : 'Request Client Vehicle Delivery'
          }}
        </form-button>

        <form-button
          level="warning"
          :indicator="requestCvcIndicator"
          :disabled="!repair_exists || cvcRequested"
          :title="repairNotSavedWarning"
          v-on:clicked="requestClientJob('client_collection')"
        >
          {{
            cvcRequested
              ? 'Client Vehicle Collection Requested'
              : 'Request Client Vehicle Collection'
          }}
        </form-button>

        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import Company from './../Shared/Company';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    'company-select': Company
  },
  data() {
    return {
      form: new window.Form(
        {
          service_id: null,
          company_id: null,
          company_name: null,
          company_email_address: null,
          company_telephone_number: null,
          company_address_line_one: null,
          company_address_line_two: null,
          company_city: null,
          company_postcode: null,
          inspection_address_line_one: null,
          inspection_address_line_two: null,
          inspection_city: null,
          inspection_postcode: null,
          storage_address_line_one: null,
          storage_address_line_two: null,
          storage_city: null,
          storage_postcode: null,
          repair_deal_reason: null,
          labour_value: null,
          parts_value: null,
          paint_materials_value: null,
          engineers_fee: null,
          admin_fee: null
        },
        true
      ),
      incident_id: null,
      requestCvcIndicator: false,
      requestCvdIndicator: false,
      cvcRequested: false,
      cvdRequested: false,
      repair_exists: false,
      data_entered: false,
      companyTypes: ['bodyshop']
    };
  },
  mounted() {
    this.mount();
  },
  computed: {
    repair() {
      return this.$store.getters['Incident/repair'];
    },
    getCompany() {
      return {
        company_id: this.form.company_id,
        name: this.form.company_name,
        email_address: this.form.company_email_address,
        telephone_number: this.form.company_telephone_number,
        address_line_one: this.form.company_address_line_one,
        address_line_two: this.form.company_address_line_two,
        city: this.form.company_city,
        postcode: this.form.company_postcode
      };
    },
    inspectionAddress() {
      return {
        address_line_one: this.form.inspection_address_line_one,
        address_line_two: this.form.inspection_address_line_two,
        city: this.form.inspection_city,
        postcode: this.form.inspection_postcode
      };
    },
    storageAddress() {
      return {
        address_line_one: this.form.storage_address_line_one,
        address_line_two: this.form.storage_address_line_two,
        city: this.form.storage_city,
        postcode: this.form.storage_postcode
      };
    },
    jobTypes() {
      return this.$store.getters['JobTypes/all'];
    },
    repairNotSavedWarning() {
      if (!this.repair_exists) {
        return 'You must save the repair details before you can instruct a job';
      }

      return undefined;
    }
  },
  methods: {
    mount() {
      this.$store.commit('JobTypes/retrieve');

      if (this.repair && this.repair.identifier) {
        this.setRepair(this.$store.getters['Incident/repair']);
      }

      this.disableClientVehicleCollectionRequest();
      this.disableClientVehicleDeliveryRequest();
    },
    setRepair(repair) {
      this.incident_id = repair.incident_id;
      this.repair_exists = true;
      this.form.company_id = repair.company_id;
      this.form.company_name = repair.company_name;
      this.form.company_email_address = repair.company_email_address;
      this.form.company_telephone_number = repair.company_telephone_number;
      this.form.company_address_line_one = repair.company_address_line_one;
      this.form.company_address_line_two = repair.company_address_line_two;
      this.form.company_city = repair.company_city;
      this.form.company_postcode = repair.company_postcode;
      this.form.inspection_address_line_one =
        repair.inspection_address_line_one;
      this.form.inspection_address_line_two =
        repair.inspection_address_line_two;
      this.form.inspection_city = repair.inspection_city;
      this.form.inspection_postcode = repair.inspection_postcode;
      this.form.storage_address_line_one = repair.storage_address_line_one;
      this.form.storage_address_line_two = repair.storage_address_line_two;
      this.form.storage_city = repair.storage_city;
      this.form.storage_postcode = repair.storage_postcode;
      this.form.repair_deal_reason = repair.repair_deal_reason;
      this.form.labour_value = repair.labour_value;
      this.form.parts_value = repair.parts_value;
      this.form.paint_materials_value = repair.paint_materials_value;
      this.form.engineers_fee = repair.engineers_fee;
      this.form.admin_fee = repair.admin_fee;
    },
    setInspectionLocation(address) {
      this.form.inspection_address_line_one = address.address_line_one;
      this.form.inspection_address_line_two = address.address_line_two;
      this.form.inspection_city = address.city;
      this.form.inspection_postcode = address.postcode;
    },

    setStorageLocation(address) {
      this.form.storage_address_line_one = address.address_line_one;
      this.form.storage_address_line_two = address.address_line_two;
      this.form.storage_city = address.city;
      this.form.storage_postcode = address.postcode;
    },

    setCompany(company) {
      this.form.company_id = company.company_id;
      this.form.company_name = company.name;
      this.form.company_email_address = company.email_address;
      this.form.company_telephone_number = company.telephone_number;
      this.form.company_address_line_one = company.address_line_one;
      this.form.company_address_line_two = company.address_line_two;
      this.form.company_city = company.city;
      this.form.company_postcode = company.postcode;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.readonly) return;
      this.setCompany(this.$refs.company.form);

      if (this.selectedService) {
        this.form.service_id = this.selectedService.id;
      }

      if (this.repair_exists) {
        this.makeRequest('put');
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },

    makeRequest(method) {
      this.form[method](`/incidents/${this.incident}/services/repair`)
        .then(response => {
          if (!this.repair_exists) {
            this.repair_exists = true;
          }
          this.$store.commit('Incident/setRepair', response);
          this.setRepair(response);
          window.toastify.success(
            'Saved',
            'The repair was saved successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "We couldn't save the repair - please try again."
          );
        });
    },
    requestClientJob(jobType) {
      const indicators = {
        client_collection: {
          request: 'requestCvcIndicator',
          requested: 'cvcRequested'
        },
        client_delivery: {
          request: 'requestCvdIndicator',
          requested: 'cvdRequested'
        }
      };

      const { request, requested } = indicators[jobType];
      this[request] = true;

      const data = {
        incident_identifier: this.incident,
        type_id: this.getJobTypeByName(jobType)?.id
      };

      window.Ajax.post('/jobs/request', data)
        .then(() => {
          this[request] = false;
          this[requested] = true;
        })
        .catch(() => {
          this[request] = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an issue creating the job'
          );
        });
    },
    getJobTypeByName(name) {
      return this.jobTypes.find(type => type.name === name);
    },
    disableClientVehicleCollectionRequest() {
      if (this.repair?.collection_job_id) {
        this.cvcRequested = true;
      }
    },
    disableClientVehicleDeliveryRequest() {
      if (this.repair?.delivery_job_id) {
        this.cvdRequested = true;
      }
    }
  }
};
</script>
